import type { LeagueScope, PermissionScopeResources } from "~types/permissionScope";
import type { SeasonTransformed } from "../types";

const extractSeasonsFromScope = (leagueTree: LeagueScope[], resources: PermissionScopeResources): SeasonTransformed[] => {
  const seasonsData = resources.seasons || {};
  const competitionsData = resources.competitions || {};
  const seasons: SeasonTransformed[] = [];

  leagueTree?.forEach(({ competitions }) => {
    competitions.forEach(({ seasonIds, competitionId }) => {
      const competitionName = competitionsData[competitionId]?.nameLocal || "";
      seasons.push(...seasonIds.map((seasonId) => ({ ...seasonsData[seasonId], competitionName })));
    });
  });

  return seasons;
};

export default extractSeasonsFromScope;
